<template>
  <div
    class="page-hero"
    :class="{ scrolled: $store.state.page.scrolled }"
    data-in-out
    data-in-out-animation="stagger-text"
  >
    <h1
      class="page-hero__title"
    >{{ title }}</h1>
    <div class="page-hero__text-wrapper" data-in-out data-in-out-animation="slide">
      <p
        class="page-hero__text"
        v-html="content[$route.name] || ''"
      >
      </p>
    </div>
  </div>
</template>

<script>
import { SplitText } from '@/scripts/libs/SplitText';
import { translate } from '@/scripts/utils';

export default {
  name: 'PageHero',

  props: ['title', 'text'],

  data() {
    return {
      content: {
        live: translate('live'),
        your: translate('your'),
        moment: translate('moment'),
        contacts: translate('contacts'),
      },
    };
  },

  mounted() {
    new SplitText(this.$el.querySelector('h1'), { charsClass: 'stagger-element' }) // eslint-disable-line
  },
};
</script>

<style lang="scss" scoped>
.page-hero {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  mix-blend-mode: multiply;

  h1 {
    position: relative;
    font-size: rem(200px);
    font-size: calc(200px * var(--rw));
    color: $color-primary;
    font-weight: 300;
    top: calc((100vh / 18) * 7);
    left: calc((100vw / 32) * 7);
    line-height: 1;
    transition: opacity 0.6s $inOutCubic,
                transform 0.6s $inOutCubic;

    @include mq($until: ds) {
      font-size: rem(220px);
      font-size: calc(220px * var(--rw));
      left: calc((100vw / 32) * 4);
    }

    @include mq($until: ipadP) {
      font-size: rem(80px);
      font-size: calc(80px * var(--rw));
      left: calc((100vw / 32) * 4);
    }
  }

  p {
    position: relative;
    font-size: rem(20px);
    font-size: calc(20px * var(--rw));
    top: calc((100vh / 18) * 8);
    left: calc((100vw / 32) * 19);
    width: calc((100vw / 32) * 9);
    transition: opacity 0.6s $inOutCubic,
                transform 0.6s $inOutCubic;

    @include mq($until: ipadL) {
      left: calc((100vw / 32) * 4);
      width: calc(100% - ((100vw / 32) * 8));
    }
  }

  &.scrolled {
    pointer-events: none;

    h1 {
      opacity: 0;
      transform: translateY(-80px);
    }

    p {
      opacity: 0;
      transform: translateY(80px);
    }
  }
}
</style>
